import React from 'react';
import EventSection from '../components/EventSection';
import Footer from '../components/Footer/Index';

const SigninPage = () => {
    return (
        <div>
            <EventSection />
            <Footer />
        </div>
    )
}

export default SigninPage;
